import $ from 'jquery';

$(function() {
    var declineRSVPBtn = $('#cwm-DeclineRSVP');
    var acceptRSVPBtn = $('#cwm-AcceptRSVP');
    var connectionAcceptRSVPBtn = $('#cwm-connectionAcceptRSVP');
    var memberRSVPModal = $("#memberRSVPModal");
    var guestFormModal = $('#addGuestRSVPFormModal');


    declineRSVPBtn.on("click", function() {        
        $('html').css({ 'overflow-y': "hidden" });
        $("#cwm-overlay").show();
        var EventData = {
            SitecoreEventId: $("#SitecoreEventId").val(),
            }
        $.ajax({
            url:'/api/sitecore/CWMEvents/ConnectionEventDeclineRSVP',
            data:EventData,
            type: "POST",
            dataType: "json",
            success: function (response) {
                console.log(response.success);
                memberRSVPModal.modal('hide');
                location.reload();
            },
            error: function (response) {                
                $('html').css({ 'overflow-y': "scroll" });
                $("#cwm-overlay").hide();
                console.log(response.error);
            }
        });
    });
    acceptRSVPBtn.on("click", function() {
        memberRSVPModal.modal('hide');
        setTimeout(function(){
            guestFormModal.modal('show'); 
        },1000);
        
    });
    if(connectionAcceptRSVPBtn.hasClass("showModalDefault")){
        memberRSVPModal.modal('show'); 
    }
});


// WEBPACK FOOTER //
// ./components/cwm-connection-event/cwm-connection-RSVP-integration.js